import { writable } from "svelte/store";

// Create a writable store for the selected station
export const selectedStation = writable(null);

// Store für die Werte
export const ozoneValues = writable([]);